/* Copyright 2015 The MathWorks, Inc. */
/**
 * This module should return an array of "types" of components in UIBuilder that are now using the new consolidated
 * Toolstrip Widgets.
 */

define([
    "../constants/TypeConstants"
], function (TypeConstants) {
    // The following will be uncommented one by one once we are ready to replace the current widgets with the new ones
    return [
		//Form Widgets:
        TypeConstants.LABEL,
        TypeConstants.PUSH_BUTTON,
        TypeConstants.TOGGLE_BUTTON,

        TypeConstants.DROP_DOWN_BUTTON,
        TypeConstants.SPLIT_BUTTON,
        TypeConstants.TOGGLE_SPLIT_BUTTON,

        TypeConstants.TEXT_FIELD,
        TypeConstants.TEXT_AREA,

        TypeConstants.CHECK_BOX,
        TypeConstants.RADIO_BUTTON,
        TypeConstants.COMBO_BOX,

        TypeConstants.SPINNER,
        TypeConstants.LIST,

		//Menu Widgets:
        TypeConstants.LIST_ITEM,
        TypeConstants.LIST_ITEM_WITH_CHECKBOX,
        TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON,
        TypeConstants.LIST_ITEM_WITH_POPUP,
        TypeConstants.LIST_ITEM_WITH_TEXTFIELD,

        TypeConstants.POPUP_LIST,
        TypeConstants.POPUP_LIST_PANEL,
        TypeConstants.POPUP_LIST_SEPARATOR,
        TypeConstants.POPUP_LIST_HEADER,

        //QAB Widgets:
        TypeConstants.QAB_PUSH_BUTTON,
        TypeConstants.QAB_TOGGLE_BUTTON,
        TypeConstants.QAB_DROP_DOWN_BUTTON,
        TypeConstants.QAB_SPLIT_BUTTON,
        TypeConstants.QAB_TOGGLE_SPLIT_BUTTON,
        TypeConstants.COLOR_PICKER_BUTTON,
        TypeConstants.GRID_PICKER_BUTTON
    ];
});
